import styled from 'styled-components';

export const TermsAndConditionsWrapper = styled.p`
  ${({ theme }) => theme.typography.tiny}
  margin: 0 auto;
  max-width: 320px;
  > a {
    color: ${({ theme }) => theme.color.charcoal};
  }
`;
